var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {enumerable: true, configurable: true, writable: true, value}) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import axios from "axios";
import {customLocalStorage} from "./customStorage";
let token = customLocalStorage.getItem("token") || void 0;
let refreshToken = customLocalStorage.getItem("refreshToken") || void 0;
export function setApiToken(newToken) {
  if (newToken) {
    customLocalStorage.setItem("token", newToken);
  } else {
    customLocalStorage.removeItem("token");
  }
  token = newToken;
}
export function setApiRefreshToken(newToken) {
  if (newToken) {
    customLocalStorage.setItem("refreshToken", newToken);
  } else {
    customLocalStorage.removeItem("refreshToken");
  }
  refreshToken = newToken;
}
export function getToken() {
  return token;
}
export function getRefreshToken() {
  return refreshToken;
}
axios.interceptors.request.use((config) => {
  if (getToken()) {
    config.headers["Authorization"] = `Bearer ${getToken()}`;
  }
  return config;
}, (error) => Promise.reject(error));
axios.interceptors.response.use((response) => response, (error) => __async(this, null, function* () {
  const originalRequest = error.config;
  if (error.response.status === 401 && !originalRequest._retry) {
    originalRequest._retry = true;
    const config = {
      url: "/auth/refresh",
      baseURL: `${process.env.REACT_APP_API_URL || "/"}api/`,
      method: "post",
      responseType: "json",
      data: {refreshToken: getRefreshToken()}
    };
    try {
      const response = yield axios.request(config);
      if (response.status < 300) {
        setApiToken(response.data.data.token);
        setApiRefreshToken(response.data.data.refreshToken);
        axios.defaults.headers.common["Authorization"] = `Bearer ${getToken()}`;
        originalRequest.headers["Authorization"] = `Bearer ${getToken()}`;
        return axios(originalRequest);
      }
    } catch (err) {
      return Promise.reject(error);
    }
  }
  return Promise.reject(error);
}));
export function serialize(data, prefix) {
  const body = [];
  if (data) {
    Object.keys(data).forEach((key) => {
      const value = data[key];
      if (typeof value === "undefined")
        return;
      const name = prefix ? `${prefix}[${key}]` : key;
      if (typeof value === "object") {
        body.push(serialize(value, name));
      } else {
        body.push(`${encodeURIComponent(name)}=${encodeURIComponent(value)}`);
      }
    });
  }
  return body.join("&");
}
export function callApi(url, params) {
  return __async(this, null, function* () {
    const headers = __spreadValues({
      "Content-Type": "application/json"
    }, params.headers || {});
    if (params.token) {
      headers["Authorization"] = `Bearer ${params.token}`;
    }
    if (params.query) {
      url = url + `?${serialize(params.query || {})}`;
    }
    const config = {
      url,
      baseURL: `${process.env.REACT_APP_API_URL || "/"}api/`,
      method: params.method || "get",
      responseType: "json",
      headers,
      data: params.body,
      params: params.params
    };
    try {
      const response = yield axios.request(config);
      return {
        ok: response.status - 200 < 100,
        status: response.status,
        headers: response.headers,
        payload: response.data || {}
      };
    } catch (err) {
      const {response = {data: {data: {}}}} = err;
      return {
        ok: response.status - 200 < 100,
        status: response.status,
        headers: new Headers(response.headers),
        payload: response.data || {data: {}}
      };
    }
  });
}
